"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TILE_SIZE = 10;
exports.CLUSTER_SIZE = 5;
exports.DIAGONAL_MOVEMENT_COST = Math.SQRT2;
exports.CLOSER_MODIFIER = 0.1;
// DEBUG CONSTANTS
exports.PERF_ITERATIONS = 0;
exports.RANDOM_PATH_INTERVAL = 500;
exports.DRAW_GRID = true;
exports.DRAW_CLUSTERS = true;
exports.START_COLOR = 'white';
exports.END_COLOR = 'white';
exports.PATH_COLOR = 'yellow';
exports.GRID_MULTIPLIER = 1;
exports.LOG_AVERAGE = false;



//////////////////
// WEBPACK FOOTER
// ./src/constants.ts
// module id = 3
// module chunks = 0